import { Platform } from 'react-native';
import * as WebBrowser from 'expo-web-browser';

/**
 * Download or open a file URL
 * On web: creates a download link and clicks it
 * On mobile: opens the URL in a browser
 */
export const downloadFile = async (url: string, filename?: string) => {
  if (Platform.OS === 'web' && typeof document !== 'undefined') {
    // Web: use traditional download link
    const link = document.createElement('a');
    link.href = url;
    if (filename) {
      link.download = filename;
    }
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // Mobile: open in browser
    await WebBrowser.openBrowserAsync(url);
  }
};

